import { SecureStorageKeys } from "constants/secureStorage";

export const secureStorage = {
  set: (key: SecureStorageKeys, value: string) => {
    return localStorage.setItem(key, value);
  },
  get: (key: SecureStorageKeys) => {
    return localStorage.getItem(key)?.replace(/^"(.*)"$/, "$1");
  },
  remove: (key: SecureStorageKeys) => {
    return localStorage.removeItem(key);
  },
};
